const initialState = {
  users: {},
  isFetching: {},
}

export default function userInfo(state = initialState) {
  return state
}
